import React from "react";
import { ModalTrackingViewContext } from "./modal-tracking-view-context";
import { useModalTrackingViewHook } from "./modal-tracking-view-hooks";
import { useContextModalTrackingView } from "./modal-tracking-view-context";

export function useModalTrackingView() {
  const { fetchModalTrackingView } = useContextModalTrackingView();

  return {
    fetchModalTrackingView,
  };
}

export function ContextModalTrackingViewProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = useModalTrackingViewHook();

  return (
    <ModalTrackingViewContext.Provider value={value}>
      {children}
    </ModalTrackingViewContext.Provider>
  );
}
